import { Inject, Injectable, isDevMode, OnDestroy } from '@angular/core';
import { AuthService } from '..';
import { Subscription } from 'rxjs';

// Was taken from https://github.com/angular/universal-starter/blob/master/src/%2Bapp/shared/cache.service.ts

@Injectable()
export class CacheService implements OnDestroy {
	static KEY = 'CacheService';
	private _subscription: Subscription;

	constructor(@Inject('LRU') public _cache: Map<string, any>,
		private _authService: AuthService) {
		this._subscription = this._authService.onTokenChanged.subscribe((token) => {
			this.clear();
		});
	}

	ngOnDestroy() {
		this._subscription.unsubscribe();
	}

	/**
	 * check if there is a value in our store
	 */
	has(key: string | number): boolean {
		let _key = this.normalizeKey(key);
		return this._cache.has(_key);
	}

	/**
	 * store our state
	 */
	set(key: string | number, value: any): void {
		let _key = this.normalizeKey(key);
		this._cache.set(_key, value);
	}

	/**
	 * get our cached value
	 */
	get(key: string | number): any {
		let _key = this.normalizeKey(key);
		return this._cache.get(_key);
	}

	/**
	 * Removes cached value.
	 * @param key Identifier.
	 */
	remove(key: string | number) {
		let _key = this.normalizeKey(key);
		return this._cache.delete(_key);
	}

	/**
	 * release memory refs
	 */
	clear(): void {
		this._cache.clear();
	}

	/**
	 * convert to json for the client
	 */
	dehydrate(): any {
		let json = {};
		this._cache.forEach((value: any, key: string) => json[key] = value);
		return json;
	}

	/**
	 * convert server json into out initial state
	 */
	rehydrate(json: any): void {
		Object.keys(json).forEach((key: string) => {
			let _key = this.normalizeKey(key);
			let value = json[_key];
			this._cache.set(_key, value);
		});
	}

	/**
	 * allow JSON.stringify to work
	 */
	toJSON(): any {
		return this.dehydrate();
	}

	/**
	 * convert numbers into strings
	 */
	normalizeKey(key: string | number): string {
		if (isDevMode() && this._isInvalidValue(key)) {
			throw new Error('Please provide a valid key to save in the CacheService');
		}

		return key + '';
	}

	_isInvalidValue(key): boolean {
		return key == null ||
			key == undefined ||
			key == 0 ||
			key == '' ||
			typeof key == 'boolean' ||
			Number.isNaN(<number>key);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/services/cache.service.ts